// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__26ytC","footer":"ReportModalFilter_footer__DVfTM"};